<template>
	<div>
		<navpage ref="navPage" :middle="true" pagename="trendUnvalidation"></navpage>

		<div id="content-page">
			<div class="row dynvibeRow">
				<trendlist />
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import trendlist from "@/components/trend/TrendList.vue";
import navpage from "@/components/globalVue/Nav.vue";

export default {
	name: "TrendUnvalidationPage",
	data() {
		return {};
	},
	components: {
		navpage: navpage,
		trendlist: trendlist,
	},
	methods: {},
};
</script>

<style scoped></style>
